import type { Direction, PlayerNumber, Vec2 } from './types';

export const COLS = 20;
export const ROWS = 15;
export const CELL_SIZE = 40;
export const VIEW_WIDTH = COLS * CELL_SIZE;
export const VIEW_HEIGHT = ROWS * CELL_SIZE;
export const FIXED_DT = 1 / 60;
export const MAX_STEPS_PER_FRAME = 5;

export const TANK_SIZE = 32;
export const TANK_PADDING = 3;
export const PLAYER_MAX_HP = 4;
export const FRONT_ARMOR_MULTIPLIER = 0.45;
export const CLASSIC_LANE_SNAP = 10;
export const CLASSIC_ALIGN_SPEED = 260;
export const BULLET_SIZE = 4.5;
export const PLAYER_RESPAWN_SECONDS = 1.4;
export const PLAYER_INVINCIBLE_SECONDS = 2.4;
export const LEVEL_COMPLETE_SECONDS = 2.2;
export const BASE_SHIELD_SECONDS = 10;
export const POWERUP_SECONDS = 10;

export const DIRECTIONS: Direction[] = ['up', 'down', 'left', 'right'];

export const DIR_VECTORS: Record<Direction, Vec2> = {
  up: { x: 0, y: -1 },
  down: { x: 0, y: 1 },
  left: { x: -1, y: 0 },
  right: { x: 1, y: 0 },
};

export const PLAYER_SPECS = [
  {
    id: 'p1',
    playerNum: 1 as PlayerNumber,
    color: 0x74c86c,
    accent: 0xd8f2a3,
    maxSpeed: 142,
    fireRate: 0.68,
    bulletSpeed: 430,
  },
  {
    id: 'p2',
    playerNum: 2 as PlayerNumber,
    color: 0x66a8d9,
    accent: 0xc9edff,
    maxSpeed: 142,
    fireRate: 0.72,
    bulletSpeed: 420,
  },
  {
    id: 'p3',
    playerNum: 3 as PlayerNumber,
    color: 0xc287f4,
    accent: 0xf1dcff,
    maxSpeed: 142,
    fireRate: 0.7,
    bulletSpeed: 425,
  },
  {
    id: 'p4',
    playerNum: 4 as PlayerNumber,
    color: 0xf0bd4e,
    accent: 0xfff1ba,
    maxSpeed: 142,
    fireRate: 0.7,
    bulletSpeed: 425,
  },
] as const;
